import Button from '@mui/material/Button'
import Avatar from '@mui/material/Avatar'
import Tooltip from '@mui/material/Tooltip'
import MenuItem from '@mui/material/MenuItem'
import TableRow from '@mui/material/TableRow'
import Checkbox from '@mui/material/Checkbox'
import TableCell from '@mui/material/TableCell'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import { useBoolean } from '../../../../hooks/use-boolean'
import { usePopover } from '../../../../components/custom-popover'
import Label from '../../../../components/label'
import CustomPopover from '../../../../components/custom-popover/custom-popover'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import Iconify from '../../../../components/iconify'
import { convertDateToDisplay } from '../../../../utils/dateUtils'
import { useEffect, useState } from 'react'
import { useDeleteCreditAppMutation } from '../../../../services'
import { useNavigate } from 'react-router-dom'
import { appRoute } from '../../../../constants'
import { useDispatch } from 'react-redux'
import { enqueueNotification } from '../../../../redux/slices/notificationsSlice'
import { Typography } from '@mui/material'

// ----------------------------------------------------------------------

type Props = {
  selected: boolean
  row: any
  onEditRow?: VoidFunction
  onSelectRow?: VoidFunction
  onDeleteRow: VoidFunction
}

export default function LeadsTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow }: Props) {
  const { name, status, email, interest, salesperson, added, updated, branch, phoneNumber } = row
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState<any>(undefined)
  const [deleteLead, { isSuccess: deleteLeadIsSuccess }] = useDeleteCreditAppMutation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleDelete = () => {
    if (deleteConfirmDialog?.id) {
      deleteConfirmDialog.leadId = deleteConfirmDialog?.id
      deleteLead(deleteConfirmDialog)
      onDeleteRow()
    }
    setDeleteConfirmDialog(undefined)
  }

  const handleEdit = (id: number | string) => {
    // TODO IMPLEMENT EDIT
    if (id) {
      navigate(appRoute.LeadsTask.replace(':leadID', String(id)))
    }
  }

  const popover = usePopover()

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell onClick={() => handleEdit(row.id)} sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
          <ListItemText
            primary={name}
            secondary={email}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              component: 'span',
              color: 'text.disabled',
            }}
          />

          <Typography variant='body2' color={'text.disabled'}>
            {phoneNumber}
          </Typography>
        </TableCell>

        <TableCell onClick={() => handleEdit(row.id)}>
          <Label
            variant='soft'
            color={(status === 'Sold' && 'success') || (status === 'pending' && 'warning') || (status === 'Lost' && 'error') || 'default'}
          >
            {status}
          </Label>
        </TableCell>

        <TableCell onClick={() => handleEdit(row.id)} sx={{ whiteSpace: 'nowrap' }}>
          {interest}
        </TableCell>

        <TableCell onClick={() => handleEdit(row.id)} sx={{ whiteSpace: 'nowrap' }}>
          {salesperson}
        </TableCell>

        <TableCell onClick={() => handleEdit(row.id)} sx={{ whiteSpace: 'nowrap' }}>
          {convertDateToDisplay(added)}
        </TableCell>
        <TableCell onClick={() => handleEdit(row.id)} sx={{ whiteSpace: 'nowrap' }}>
          {convertDateToDisplay(updated)}
        </TableCell>
        <TableCell onClick={() => handleEdit(row.id)} sx={{ whiteSpace: 'nowrap' }}>
          {branch}
        </TableCell>

        <TableCell align='right' sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon='eva:more-vertical-fill' />
          </IconButton>
        </TableCell>
      </TableRow>

      {/* <UserQuickEditForm currentUser={row} open={quickEdit.value} onClose={quickEdit.onFalse} /> */}

      <CustomPopover open={popover.open} onClose={popover.onClose} arrow='right-top' sx={{ width: 140 }}>
        <MenuItem
          onClick={() => {
            handleEdit(row.id)
            popover.onClose()
          }}
        >
          <Iconify icon='solar:pen-bold' />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setDeleteConfirmDialog(row)
            popover.onClose()
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon='solar:trash-bin-trash-bold' />
          Delete
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={!!deleteConfirmDialog}
        onOk={handleDelete}
        handleClose={() => setDeleteConfirmDialog(undefined)}
        notification={'Lead will be removed'}
      />
    </>
  )
}
